/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const Roles = Object.freeze({
  SUBMISSION_DRAFTER: 'ROLE_DRAFTER', // submission drafter
  SUBMISSION_SIGNER: 'ROLE_SIGNER', // submission signer
  SUBMISSION_SENDER: 'ROLE_SENDER', // submission sender
  SUBMISSION_PAYER: 'ROLE_PAYER', // submission payer
  END_USER_ADMIN: 'ROLE_END_USER_ADMIN', // user management admin for an organization
});

export const ExtraRoles = Object.freeze({
  SUBMISSION_SIGN: 'SIGNER',
});

export const UserRoles = {
  ROLE_DRAFTER: {
    id: 'ROLE_DRAFTER',
    name: 'Drafter',
    i18nKey: 'user.role.drafter',
    order: 1,
  },
  ROLE_SIGNER: {
    id: 'ROLE_SIGNER',
    name: 'Signer',
    i18nKey: 'user.role.signer',
    order: 2,
  },
  ROLE_SENDER: {
    id: 'ROLE_SENDER',
    name: 'Sender',
    i18nKey: 'user.role.sender',
    order: 3,
  },
  ROLE_PAYER: {
    id: 'ROLE_PAYER',
    name: 'Payer',
    i18nKey: 'user.role.payer',
    order: 4,
  },
  END_USER_ADMIN: {
    id: 'ROLE_END_USER_ADMIN',
    name: 'Admin',
    i18nKey: 'user.role.admin',
    order: 5,
  },
};

export const getRoleById = id => Object.values(UserRoles).find(role => role.id === id);
